<div class="project-requirement container">
    <div class="d-md-flex justify-content-between align-items-center mb-2">
        <div class="d-flex align-items-center">
            <h2 class="improved-page-label me-3">Project Documents</h2>
            <img class="mx-1" height="14px" width="14px" [src]="imagePath + 'info-blue.svg'" alt="info">
            <span class="fw-normal ms-1">All fields are optional for this page, you can skip it.</span>
        </div>
        <button type="button" class="btn btn-primary improved-add-btn mt-3 mt-md-0" (click)="SubmitProductRequirement()">View Quotation</button>
    </div>

    <div class="project-requirement-form row">
        <div class="col-12 col-lg-5">
            <div class="field-box">
                <!-- <label for="project-duration" class="attachment-label mb-1">Attachment</label> -->
                  <div class="e-quote-upload-container mb-0" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
                    <div (click)="fileInput.click()" class=" cursor-pointer">
                      <img class="mx-1 mb-2" height="24px" width="24px" [src]="imagePath + 'green-upload.svg'" alt="info" >
                    <p><b>Upload Documents</b></p>
                    <span class="drag-text mb-0 label">Upload you project documents. 
                      <span class="browse-text" > </span>
                    </span>
                  </div>
                    <input #fileInput class="file-input" type="file" (change)="onFileSelect($event)"
                      style="display:none" multiple>
                 
                  <div>
                    <button class="choose-file-button d-none" type="button" (click)="fileInput.click()">Choose file</button>
                  </div>
                </div>
              </div>
              <div class="field-box file-section-main">
                <div class="d-flex  file-upload-header justify-content-between align-items-center my-1">
                  <div>
                    <label for="project-duration" *ngIf="uploadedFiles.length > 0" class="label file-count">
                      {{uploadedFiles.length}} File{{uploadedFiles.length > 1 ? 's' : ''}} Uploaded
                    </label>
                  </div>
                  <div>
                    <!-- <button *ngIf="uploadedFiles.length === 1" class="remove-all-button"
                      (click)="removeFile(0)">Remove</button> -->
                    <button *ngIf="uploadedFiles.length > 1" class="remove-all-button mt-2" (click)="removeAllFiles()">Remove
                      All</button>
                  </div>
                </div>
                
                  <div class="d-flex flex-column mt-2 file-list-container">
                    <div *ngFor="let file of uploadedFiles; let i = index" class="e-quote-file-display d-flex">
                      <img class="file-icon" src="{{fileIconService.getFileTypeIcon(file.vFileName || file.name)}}" alt="file-icon">
                      <span *ngIf="!file._id" class="file-name drag-text">{{ file.name }}</span>
                      <span *ngIf="file._id" class="file-name drag-text">{{file.vFileName}}</span>
                      <button class="remove-button remove-btn-hover" (click)="removeFile(i,file._id)">
                        <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color"
                          aria-hidden="true" data-mat-icon-type="font">delete</mat-icon>
                      </button>
                    </div>
                
                </div>
              </div>
        </div>
        <div class="col-12 col-lg-7 px-3">
            <h3 class="heading-1 mb-3">Project Requirement Form</h3>
            <form id="ProductRequirement" [formGroup]="ProductRequirement">
                <!-- <div class="form-control-box bottom-spacing">
                    <label for="vProjectName" class="label">Project Name</label>
                    <div>
                        <mat-form-field appearance="outline" class="improved-input w-100">
                          <input matInput id="vProjectName" placeholder="Enter Project Name" formControlName="vProjectName">
                        </mat-form-field>
                      </div>
                      <div class="input-details-box no-mat-input justify-content-end">
                      <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                        *ngIf="hasError(ProductRequirement, 'vProjectName', 'maxlength')">
                        Must not exceed 100 characters!
                      </mat-error>
                    </div>
                </div> -->
                <div class="form-control-box bottom-spacing">
                    <label for="vProjectDescription" class="label">Project Description / Information</label>
                    <div>
                        <mat-form-field appearance="outline" class="improved-textarea">
                          <textarea matInput rows="5" id="vProjectDescription" placeholder="Write your project's description here"
                          formControlName="vProjectDescription" #input></textarea>
                      </mat-form-field>
                      </div>
                      <div class="input-details-box no-mat-input justify-content-end">
                        <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                          *ngIf="hasError(ProductRequirement, 'vProjectDescription', 'maxlength')">
                          Must not exceed 1000 characters!
                        </mat-error>
                      </div>
                </div>
                <div class="row">
                    <label for="range" class="e-quote-title">What is the range of your budget?</label>
                    <div class="col-7">
                        <div class="form-control-box ">
                            <mat-slider min="10000" max="1000000">
                                <input [value]="minPrice.value" [disabled]="rangeDisabled" (input)="onMinSliderChange($event);" matSliderStartThumb>
                                <input [value]="maxPrice.value" [disabled]="rangeDisabled" (input)="onMaxSliderChange($event)" matSliderEndThumb>
                            </mat-slider>
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="sub-label">{{currencyFlag == 1 ? '₹' : '$'}}10K</span>
                                <span class="sub-label">{{currencyFlag == 1 ? '₹' : '$'}}1M+</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-5">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-control-box ">
                                    <label for="iMinPrice" class="label">Min Price ({{currencyFlag == 1 ? '₹' : '$'}})</label>
                                    <div>
                                        <mat-form-field appearance="outline" class="improved-input w-100">
                                          <input type="number" min="10000" #minPrice formControlName="iMinPrice" matInput placeholder="$">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-control-box ">
                                    <label for="iMaxPrice" class="label">Max Price ({{currencyFlag == 1 ? '₹' : '$'}})</label>
                                    <div>
                                        <mat-form-field appearance="outline" class="improved-input w-100">
                                          <input type="number" #maxPrice matInput formControlName="iMaxPrice" placeholder="$">
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-control-box idontknow-checkbox my-2">
                  <div>
                    <mat-checkbox (change)="DontKnowValueChange($event)" formControlName="iDontKnow" class="label">I’m not sure yet</mat-checkbox>
                  </div>
                </div>
                <div class="form-control-box ">
                    <label for="vReferenceLink" class="label">Share Competitive Product or Company reference if you have in your mind.</label>
                    <div>
                      <mat-form-field appearance="outline" class="improved-input w-100">
                        <input
                          matInput
                          id="vReferenceLink"
                          placeholder="Enter URL"
                          formControlName="vReferenceLink"
                        />
                      </mat-form-field>
                    </div>
                    <div class="input-details-box no-mat-input justify-content-end">
                      <mat-error
                        class="w-100 increase-z-index error-top-spacing error-message"
                        *ngIf="ProductRequirement?.get('vReferenceLink')?.hasError('pattern')"
                      >
                        Invalid URL!
                      </mat-error>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
